import Vue from 'vue';

export default Vue.directive('app-back-button', {
  bind: (el) => {
    el.addEventListener('click', () => history.back());
  },
});
